import { useCallback } from 'react';

import { useAiAssistantTranscriptionContext } from '../shared/AiAssistantTranscription.context';

type TranscriptionSessionEndActionRenderProps = {
   endTranscriptionSession: VoidFunction;
   discardTranscriptionSession: VoidFunction;
};

type TranscriptionSessionEndActionProps = {
   children: (renderProps: TranscriptionSessionEndActionRenderProps) => JSX.Element;
};

export const TranscriptionSessionEndAction = (props: TranscriptionSessionEndActionProps): JSX.Element => {
   const transcription = useAiAssistantTranscriptionContext();

   const endTranscriptionSession = useCallback(() => {
      transcription.stop();
   }, [transcription]);

   const discardTranscriptionSession = useCallback(() => {
      transcription.stop();
      transcription.clearTranscript();
   }, [transcription]);

   return props.children({
      endTranscriptionSession: endTranscriptionSession,
      discardTranscriptionSession: discardTranscriptionSession,
   });
};
